/**
 * Created by baladewa on 5/20/16.
 */
'use strict';
(function () {
    angular
        .module('commons')
        .component('trainingProgramsComponent', {
            templateUrl: 'training-programs/components/training-programs-component.tpl.html',
            controller: function (EventManagerService, applicationConstants, $timeout, ContextMenuService,PopupManager,MessageService) {
                var vm = this, noOfDays=1,min_screen_width=1200,dayWidth=0;
                vm.viewType =null;
                vm.hourCols = [];
                vm.trainingWidth = 40;
                vm.trainMargin=2;
                vm.rowHeightInPx = 0;
                vm.programData = [];
                vm.filteredData = {};
                vm.screen_left_panel = 60;
                vm.minItemsPerDay = 0;
                vm.widthOfscroll=0;
                vm.monthCategoryToggle=false;
                vm.trainingEditorToggle=false;
                vm.programCategory={};
                vm.selectedTraining = {};


                vm.actual_screen_width = window.innerWidth;
                vm.screen_right_panel = min_screen_width;
                if (!!vm.actual_screen_width && vm.actual_screen_width > min_screen_width) {
                    vm.screen_right_panel = vm.actual_screen_width - vm.screen_left_panel;
                }

                EventManagerService.registerEventListener(EventManagerService.EVENT.TRAINING_PROGRAME.VIEW_CHANGED, function(data){
                    vm.viewType = data;
                    vm.monthCategoryToggle = false;
                    vm.trainingEditorToggle = false;
                    renderTimeLine();
                });

                EventManagerService.registerEventListener(EventManagerService.EVENT.TRAINING_PROGRAME.DATA_CHANGED, function(data){
                    vm.programData = [];
                    $timeout(function(){
                        vm.programData = data;
                        formatData();
                        updateDayView();
                    });
                });

                EventManagerService.registerEventListener(EventManagerService.EVENT.TRAINING_PROGRAME.ADD_TRAINING_COMP, function(trainingData){
                    vm.selectedTraining = trainingData;
                    vm.monthCategoryToggle = false;
                    vm.trainingEditorToggle = true;
                });

                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_CREW_TO_TRAINING,onAssignCrewToTraining)


                if($(".tabbed-view-container").height() == 0)
                	$(".tabbed-view-container").height(80);

                var height=($("header").height() + $(".tabbed-view-container").height())+"px";
            	$(".canvas").css("top", height);

                vm.dblOnDay = function (evt, day) {
                    var options = {};
                    options.selectedDate = day;
                    vm.goToDate(options);
                };

                vm.expandToggle = function (e, dayObj) {
                    dayObj.expand = !dayObj.expand;
                    if (dayObj.expand){
                        dayObj.dayWidth = (vm.trainingWidth + vm.trainMargin) * dayObj.total;
                        dayObj.itemsLimit = dayObj.total;
                        vm.widthOfscroll = ( vm.widthOfscroll + dayObj.dayWidth ) - ((vm.trainingWidth + vm.trainMargin) * vm.minItemsPerDay);
                    }else{
                        dayObj.dayWidth = dayWidth;//(vm.trainingWidth + vm.trainMargin) * vm.minItemsPerDay;
                        dayObj.itemsLimit = vm.minItemsPerDay;
                        vm.widthOfscroll = ( vm.widthOfscroll + ((vm.trainingWidth + vm.trainMargin) * vm.minItemsPerDay) ) - (vm.trainingWidth + vm.trainMargin) * dayObj.total;
                    }
                    var scrollLeft = dayWidth;
                    angular.element('.category-right-section').animate({ scrollLeft: scrollLeft }, 'slow');
                };

                vm.clickOnMonthCategory = function (evt, category, date, categoryLabel) {
                    var cats = category, trainingArr = [];
                    if(category.hasOwnProperty('categoryData')){
                        cats = [];
                        cats[0] = category;
                    }
                    if(cats.length!==0){
                        vm.programCategory.categoryData = getTrainingFromCategory(cats, categoryLabel);
                        vm.programCategory.selectedDate = moment(date, applicationConstants.SETTINGS.DATE_FORMAT).format('dddd, D MMMM YYYY');
                        vm.programCategory.selectedDateUnFormatted = date;
                        vm.programCategory.category = categoryLabel;
                        vm.monthCategoryToggle = true;
                        vm.trainingEditorToggle = false;
                        evt.stopPropagation();
                    }
                };


                vm.clickOnTrainingProgram =function (event, selectedTraining) {

                  vm.selectedTraining = selectedTraining;
                    vm.selectedTraining.isRightClick = false;
                    vm.trainingEditorToggle = true;
                    var options = {
                        event:event,
                        selectedTraining: selectedTraining
                    };
                   vm.onSelectTraining(options);
                };

                vm.getContextMenu = function (type, selectedTraining) {
                	var menuType = angular.copy(type);//default type
                    if(!vm.multiSelected){
                        vm.selectedTraining = selectedTraining;
                        vm.selectedTraining.isRightClick = true;
                        vm.trainingEditorToggle = true;
                        var options = {
                            event:event,
                            selectedTraining: selectedTraining
                        };
                        vm.onSelectTraining(options);
                    } else {
                    	menuType = 'MULTIPLE_TRAINING_SELECTION';
                    }
                    return ContextMenuService.getContextMenu(menuType);
                };

                vm.keyPressed = function (event) {
                    if (event.key === "Delete") {
                     EventManagerService.notifyEventListeners(EventManagerService.EVENT.CONTEXT_MENU.DELETE_BLOCK);
                   }
                };
                  vm.onBlockHover = function (e, block) {
                    vm.blockToolTiop = block;
                    var findCheckPosition = function () {
                      var H = 'left', V = 'top';
                      if ((e.clientX + e.target.offsetWidth + 100) > vm.screen_right_panel) {
                        H = 'left';
                      } else {
                        H = 'right';
                      }
                      if ((e.clientY + e.target.offsetHeight + 100) > vm.comHeight) {
                        V = 'bottom';
                      } else {
                        V = 'top';
                      }
                      return H + '-' + V;
                    };

                    vm.toolTipPosition = findCheckPosition();
                  };

                function renderTimeLine(){
                    if(vm.viewType==='M'){
                        buildMonthCalendar();
                    }else{
                        noOfDays=1;
                        if(vm.viewType==='W'){
                            noOfDays=7;
                        }

                    }
                    buildDayCalendar();
                }

                function updateDayView(){
                    if(vm.monthCategoryToggle){
                        $timeout(function () {
                            var date = vm.programCategory.selectedDateUnFormatted;
                            var dataForDate = getDayObjFromDate(date);
                            vm.programCategory.categoryData = getTrainingFromCategory(dataForDate, vm.programCategory.category);
                        },0)
                    }
                }

                function buildMonthCalendar() {
                    var mom = moment(vm.startDate, applicationConstants.SETTINGS.DATE_FORMAT);
                    var yyyy = mom.year();
                    var mm = mom.month() + 1;
                    noOfDays = mom.daysInMonth();//get the no of days of the month
                    var monthStartDay = new Date(yyyy + "-" + mm + "-01").getDay();
                    var noOfWeeks = Math.ceil((noOfDays+monthStartDay) / 7),weeksArray=[];

                    var sMonth = String(mm).length===1?"0"+mm:mm;
                    var tempDate = moment("01/" + sMonth + "/" +yyyy, applicationConstants.SETTINGS.DATE_FORMAT);
                    var displayStartDate = tempDate.add(-monthStartDay, 'days');

                    for(var i=0;i<noOfWeeks;i++){
                        var week = {
                            index:i,
                            days:[]
                        };
                        for(var j=0;j<7;j++) {
                            var day = {
                                dayIndex:j,
                                date: displayStartDate.format(applicationConstants.SETTINGS.DATE_FORMAT),
                                current: displayStartDate.format(applicationConstants.SETTINGS.DATE_FORMAT) === moment().format(applicationConstants.SETTINGS.DATE_FORMAT),
                                items:[],
                                active: mm == (displayStartDate.month()+1)
                            };
                            displayStartDate.add(1,'days');
                            week.days.push(day);
                        }
                        weeksArray.push(week);
                    }
                    vm.monthCreated = weeksArray;
                }

                function buildDayCalendar() {
                    vm.hourCols = {};
                    dayWidth = Math.floor((vm.screen_right_panel-(80+14))/noOfDays);
                    vm.minItemsPerDay = Math.floor(dayWidth/(vm.trainingWidth + vm.trainMargin));


                    vm.rowHeightInPx = vm.trainingWidth;
                    vm.minuteToPixelRatio = (vm.rowHeightInPx * 24) / (60 * 24);
                    var hours = [];
                    for (var i=0;i<24;i++){
                        var k = i;
                        if (i>23){
                            k = 0;
                        }
                        hours.push({
                            hourLabel: String(k).length==1?"0"+k+":00":k+":00"
                        });
                    }
                    vm.hourCols = hours;
                }

                function formatTraining(training){
                    var temp = training;
                    temp.height = getTimeInMinFromStartDate(training.startDate, training.endDate, training.endTime) - getTimeInMinFromStartDate(training.startDate, training.startDate, training.startTime);
                    temp.topPos = getTimeInMinFromStartDate(training.startDate, training.startDate, training.startTime);
                    temp.bgColor = getColorByCategory(training);
                    temp.statusIcon = getIconByStatus(training);
                    temp.selectedFlag = false;
                    return temp;
                }

                function getIconByStatus(training){
                    var st = "check_circle";
                    if(training.trainingProgramStatusCode==="TENTATIVE"){
                        st = "error";
                    }else if(training.trainingProgramStatusCode==="CANCELLED"){
                        st = "block";
                    }else if(training.trainingProgramStatusCode==="DELETED"){
                        st = "block";
                    }
                    return st;
                }

                function getColorByCategory(training) {

                  if(training.trainingColorCode != null && training.trainingColorCode !== '') {
                    return training.trainingColorCode;
                  }
                    return applicationConstants.TRAINING_COLOR_MAP[training.trainingProCategory];
                }

                function getTimeInMinFromStartDate(startDate, checkInDate, checkInTime) {
                    var stD = moment(startDate, applicationConstants.SETTINGS.DATE_FORMAT);
                    var enD = moment(checkInDate, applicationConstants.SETTINGS.DATE_FORMAT);

                    var mo_checkIn = moment(checkInDate + ' ' + checkInTime, applicationConstants.SETTINGS.DATE_TIME_FORMAT);
                    if(enD.diff(stD)>0){
                        mo_checkIn = moment(startDate + ' 23:59', applicationConstants.SETTINGS.DATE_TIME_FORMAT);
                    }

                    var stDate = moment(startDate + ' 00:00', applicationConstants.SETTINGS.DATE_TIME_FORMAT);
                    var diffFromStart = mo_checkIn.diff(stDate, 'm');
                    return Math.round(diffFromStart * vm.minuteToPixelRatio);
                }

                function getTrainingFromCategory(categories, cat) {
                    var trainingArr = [];
                    angular.forEach(categories, function (category) {
                        if (cat === category.category || cat==='ALL'){
                            angular.forEach(category.categoryData, function (training) {
                                trainingArr.push(training);
                            });
                        }

                    });
                    return trainingArr;
                }

                function clearDatesItems() {
                    for(var i=0;i<vm.monthCreated.length;i++){
                        var week = vm.monthCreated[i];
                        for(var j=0;j<week.days.length;j++) {
                            week.days[j].items = [];
                        }
                    }
                }

                function setDayObjByDate(date, dayContent) {
                    var exitTop = true;
                    for(var i=0;i<vm.monthCreated.length;i++){
                        var week = vm.monthCreated[i];
                        if(!exitTop){
                            break;
                        }
                        for(var j=0;j<week.days.length;j++) {

                            var stD = moment(date, applicationConstants.SETTINGS.DATE_FORMAT);
                            var enD = moment(week.days[j].date, applicationConstants.SETTINGS.DATE_FORMAT);
                            if (enD.diff(stD)===0){
                                week.days[j].items = dayContent;
                            }
                        }
                    }
                }

                function getDayObjFromDate(date) {
                    var exitTop = true, dayContent=null;
                    for(var i=0;i<vm.monthCreated.length;i++){
                        var week = vm.monthCreated[i];
                        if(!exitTop){
                            break;
                        }
                        for(var j=0;j<week.days.length;j++) {
                            var stD = moment(date, applicationConstants.SETTINGS.DATE_FORMAT);
                            var enD = moment(week.days[j].date, applicationConstants.SETTINGS.DATE_FORMAT);
                            if (enD.diff(stD)===0){
                                dayContent  = week.days[j].items
                                break;
                            }
                        }
                    }
                    return dayContent;
                }

                function formatData() {
                    vm.filteredData = {};
                    clearDatesItems();
                    var timeAdded = _.each(vm.programData, function(program){
                        program.timeValue = moment(program.startDate, applicationConstants.SETTINGS.DATE_FORMAT).valueOf();
                        return program
                    });
                    var orderedList = _.groupBy(timeAdded, 'timeValue');
                    var keys = Object.keys( orderedList );
                    keys.sort( function ( a, b ) { return a - b; } );
                    var groupedData = {};
                    for ( var i = 0; i < keys.length; i++ ) {
                        groupedData[orderedList[keys[i]][0]['startDate']] = orderedList[ keys[i] ];
                    }
                    var dayLength=0;
                    angular.forEach(groupedData, function(group, key){
                        dayLength ++;
                        if (vm.viewType==='D'){
                            vm.minItemsPerDay = group.length
                        }
                        var tempBlock = {
                            items: !!vm.filteredData[key]?vm.filteredData[key].items:[],
                            begin: 0,
                            expand:false,
                            itemsLimit: vm.minItemsPerDay,
                            dayWidth: dayWidth, //(vm.trainingWidth + vm.trainMargin) * vm.minItemsPerDay,
                            total: 0
                        };
                        //var keyGroup = vm.filteredData[key] || [];
                        angular.forEach(group, function(item){
                            tempBlock.items.push(formatTraining(item));
                        });
                        tempBlock.total = tempBlock.items.length;
                        if(vm.viewType==='M'){
                            var tempDay = _.groupBy(tempBlock.items,'trainingProCategory');
                            var arrCat = [];
                            for (var cat in tempDay){
                                var catItem = {
                                    category:cat,
                                    categoryData: tempDay[cat],
                                    color: getColorByCategory({'trainingProCategory':cat}),
                                    total: tempDay[cat].length
                                };
                                arrCat.push(catItem);
                            }
                            setDayObjByDate(key, arrCat);
                        }else{
                            vm.filteredData[key] = tempBlock;
                        }
                    });
                    vm.widthOfscroll = dayWidth * dayLength;
                }

                function onAssignCrewToTraining () {
                    if(vm.selectedTraining && vm.selectedTraining.subPrograms){
                        var param  = {
                            selectedTraining : vm.selectedTraining
                        };
                        PopupManager.openModal('TRAINING_ASSIGN_CREW',param,onAssignCrewPopupClose);
                    }else{
                        MessageService.warning('Trainign program is not assigned');
                    }
                };

                function onAssignCrewPopupClose (param) {

                }

            },
            bindings: {
                startDate: '<',
                endDate: '<',
                multiSelected: '=',
                onSelectTraining: '&',
                goToDate:'&'
            }
        }
    )
})();
